import { SearchPageType } from 'store/slice/slice.types';
import { search as getLocationSearch, pathname as getLocationPathname } from 'core-framework/window/location';
import { getCityIdQueryParams, getKeywordQueryParams } from 'gql/service/graph/activityService';

export const determineSearchPageType = (): SearchPageType => {
    const isSearchPage = getLocationPathname().includes('/search');
    const hasCityId = !!getCityIdQueryParams(getLocationSearch());
    const hasKeyword = !!getKeywordQueryParams(getLocationSearch());

    if (isSearchPage && hasCityId && !hasKeyword) {
        return SearchPageType.City;
    }
    if (isSearchPage && hasCityId && hasKeyword) {
        return SearchPageType.InCityText;
    }
    if (isSearchPage && !hasCityId && hasKeyword) {
        return SearchPageType.TextSearch;
    }

    return SearchPageType.None;
};
